export enum DocumentContentSubType {
	MAIN_DIAGNOSIS = 'main_diagnosis',
	SECONDARY_DIAGNOSIS = 'secondary_diagnosis',
}
